module.exports = __webpack_public_path__ + "img/calculator.2eb1a500.svg";